import { Schema } from 'mongoose';

export interface ITripPricingElement {
  adults: number;
  children: number;
  infants: number;
  price: number;
  pricePerDay: number;
}

const tripPricingElement = new Schema(
  {
    adults: {
      type: Number,
      required: true,
      default: 0,
    },
    children: {
      type: Number,
      required: true,
      default: 0,
    },
    infants: {
      type: Number,
      required: true,
      default: 0,
    },
    price: {
      type: Number,
      required: true,
    },
    pricePerDay: {
      type: Number,
      required: true,
    },
  },
  { _id: false },
);

export default tripPricingElement;
